import { render, staticRenderFns } from "./InvocationScrollableTable.vue?vue&type=template&id=0e55ab62&scoped=true"
import script from "./InvocationScrollableTable.vue?vue&type=script&lang=ts"
export * from "./InvocationScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./InvocationScrollableTable.vue?vue&type=style&index=0&id=0e55ab62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e55ab62",
  null
  
)

export default component.exports